// 3rd Party
import _ from 'lodash';

// Other
import { colors } from 'common/styles/style-constants';

import { PARTNER_CHECKOUT_STEPS } from '../definitions/partnerCheckoutSteps';
import { PATIENT_CHECKOUT_STEPS } from '../definitions/patientCheckoutSteps';

// Exports

export const getCheckoutStepId = (currentStepName, data) => {
  const steps = getCheckoutSteps(data);
  return _.findIndex(steps, step => step.name === currentStepName);
};

export const nextActiveStepName = (currentStepId, data, direction) => {
  const steps = getCheckoutSteps(data);
  let nextStep;

  if (direction === 'back') {
    nextStep = steps.find(
      (step, i) => i < currentStepId && !step.isHidden(data),
    );
  } else {
    nextStep = steps.find(
      (step, i) => i > currentStepId && !step.isHidden(data),
    );
  }

  return nextStep && nextStep.name;
};

export const progressStepColor = (activeStepId, index) => {
  if (activeStepId === index + 1 || activeStepId > index + 1) {
    return colors.blue;
  }

  return colors.gray7;
};

export const getCheckoutSteps = data => {
  const partner = _.get(data, 'user.partner');
  return partner ? PARTNER_CHECKOUT_STEPS : PATIENT_CHECKOUT_STEPS;
};
